module.exports = {
      id: "cinema-usage",
      viewBox: "0 0 26.501 25.377",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#cinema",
      toString: function () {
        return this.url;
      }
    }